import React from 'react';
import ReactDOM from 'react-dom/client';
// import './indexs.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css'
import App from './App';
import reportWebVitals from './reportWebVitals';
import './theme.css';
import { createStore } from 'redux';
import allReducers from './store/reducer';
import { Provider } from 'react-redux';
import ReactGA from 'react-ga';

ReactGA.initialize('G-2TH93J2B1X');
ReactGA.pageview(window.location.pathname + window.location.search);

const store = createStore(
  allReducers,
  window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__()
);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(    
  <React.StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
